<template>
  <div class="teaching-evaluation">
    <!-- 教学评价维度分析 -->
    <div class="evaluation-radar chart-item">
      <div class="chart-header">
        <span class="chart-title">教学评价维度分析</span>
      </div>
      <Echart :options="radarOptions" height="220px" />
    </div>

    <!-- 教学满意度趋势 -->
    <div class="satisfaction-trend chart-item">
      <div class="chart-header">
        <span class="chart-title">教学满意度趋势</span>
      </div>
      <Echart :options="trendOptions" height="220px" />
    </div>

    <!-- 评教统计 -->
    <div class="evaluation-stats chart-item">
      <div class="chart-header">
        <span class="chart-title">评教统计</span>
      </div>
      <div class="stat-cards">
        <div class="stat-card" v-for="(item, index) in statsData" :key="index">
          <div class="stat-value">{{ item.number.number[0] }}</div>
          <div class="stat-label">{{ item.text }}</div>
          <div class="progress-bar">
            <div class="progress" :style="{ width: item.number.number[0] + '%' }"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'

export default {
  data() {
    return {
      radarOptions: {},
      trendOptions: {},
      statsData: [
        {
          number: {
            number: [89.7],
            toFixed: 1
          },
          text: '教学方法'
        },
        {
          number: {
            number: [90.0],
            toFixed: 1
          },
          text: '教学内容'
        },
        {
          number: {
            number: [85.7],
            toFixed: 1
          },
          text: '课堂氛围'
        }
      ]
    }
  },
  components: {
    Echart
  },
  mounted() {
    this.initCharts()
  },
  methods: {
    initCharts() {
      // 雷达图配置
      this.radarOptions = {
        radar: {
          indicator: [
            { name: '教学方法', max: 100 },
            { name: '教学内容', max: 100 },
            { name: '课堂氛围', max: 100 },
            { name: '互动质量', max: 100 },
            { name: '作业反馈', max: 100 }
          ],
          splitArea: {
            areaStyle: {
              color: ['rgba(255,255,255,0.05)']
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          name: {
            textStyle: {
              color: '#fff'
            }
          }
        },
        series: [{
          type: 'radar',
          data: [{
            value: [89.7, 90.0, 85.7, 88.5, 87.2],
            name: '评分',
            areaStyle: {
              color: new this.$echarts.graphic.RadialGradient(0.5, 0.5, 1, [
                { offset: 0, color: 'rgba(65,105,225,0.5)' },
                { offset: 1, color: 'rgba(65,105,225,0.1)' }
              ])
            },
            lineStyle: {
              color: '#4169e1',
              width: 2
            },
            itemStyle: {
              color: '#4169e1'
            }
          }]
        }]
      }

      // 满意度趋势图配置
      this.trendOptions = {
        grid: {
          top: '15%',
          right: '5%',
          bottom: '12%',
          left: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['第1周', '第2周', '第3周', '第4周', '第5周', '第6周'],
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        yAxis: {
          type: 'value',
          min: 80,
          max: 100,
          splitLine: {
            lineStyle: { color: 'rgba(255,255,255,0.1)' }
          },
          axisLine: {
            lineStyle: { color: 'rgba(255,255,255,0.2)' }
          },
          axisLabel: { color: '#fff' }
        },
        series: [
          {
            type: 'line',
            data: [85, 88, 87, 90, 89, 92],
            smooth: true,
            symbol: 'circle',
            symbolSize: 8,
            lineStyle: {
              width: 3,
              color: '#67e0e3'
            },
            itemStyle: {
              color: '#67e0e3',
              borderWidth: 2,
              borderColor: '#fff'
            },
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(103,224,227,0.5)' },
                { offset: 1, color: 'rgba(103,224,227,0.1)' }
              ])
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.teaching-evaluation {
  padding: 10px;
  height: 100%;
  display: grid;
  grid-template-rows: auto auto auto;
  gap: 15px;

  .chart-item {
    background: rgba(6, 30, 93, 0.5);
    border-radius: 4px;
    padding: 10px;
    backdrop-filter: blur(4px);
    box-shadow: 0 0 10px rgba(0,0,0,0.2);

    .chart-header {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .chart-title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
        &::before {
          content: '';
          display: inline-block;
          width: 4px;
          height: 16px;
          background: #67e0e3;
          margin-right: 8px;
          vertical-align: middle;
          border-radius: 2px;
        }
      }
    }
  }

  .stat-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 15px;
    padding: 10px;

    .stat-card {
      background: rgba(6, 30, 93, 0.7);
      border-radius: 8px;
      padding: 15px;
      text-align: center;

      .stat-value {
        font-size: 24px;
        color: #67e0e3;
        font-weight: bold;
        margin-bottom: 5px;
      }

      .stat-label {
        color: #fff;
        font-size: 14px;
        margin-bottom: 10px;
      }

      .progress-bar {
        width: 100%;
        height: 4px;
        background: rgba(255,255,255,0.1);
        border-radius: 2px;
        overflow: hidden;

        .progress {
          height: 100%;
          background: linear-gradient(to right, #67e0e3, #4169e1);
          border-radius: 2px;
          transition: width 0.3s ease;
        }
      }
    }
  }
}
</style> 